// [init]

export default {


	namespaced: true,

	state: {
		// Listing of all packages ( Array )
		packagesList: [],

		// Current Package being manipulated ( viewed or edited ) ( Object )
		status: '',
		activePackage: {}
	},

	mutations: {

		// Update packageList with new list
		// @params: Array
		updatePackageList( state, newList ) {
			state.packagesList = newList.map(item => {
				item.price = item.price / 100;
				return item;
			});
		},

		// Add a package into packageList
		addPackage( state, newPackage ) {
			state.packagesList.push( newPackage );
		},

		// Delete a package from packageList
		// @params: identifier (String)
		deletePackage( state, identifier ) {
			state.packagesList = state.packagesList.filter(item => {
				return item.id != identifier;
			});
		},

		// Update the current active Package object
		// @params: newActivePackage (Object)
		updateActivePackage( state, newActivePackage ) {
			state.activePackage = newActivePackage;
		},

		// Change status of packageForm
		// @params: newStatus (String)
		updateStatus( state, newStatus ) {
			state.status = newStatus;
		},

		resetState( state ) {
			state.status = '';
			state.activePackage = {};
		}

	},

	actions: {
		
		getName( { commit, state }, mang ) {

			return new Promise ((resolve, reject ) => {

				global.axios.request({
					method: 'post',
					url: '/packages/getname',
					validateStatus: ( status ) => { return status == 200; },
					data : mang
				})
				.then(response => {
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},
		
		/* 
		*  /GET packages API
		*  Get all packages from the server
		*  @return: Array
		*/
		getPackages( { commit, state } ) {

			return new Promise (( resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/packages',
					params: {
						trash: this.state.auth.type == 'admin' ? '*' : '0',
						from: 0,
						size: 9999999
					},
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'updatePackageList', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /GET/:id packages API
		*  Get a single package from the server
		*  @params: Array (due to vuex limitations)
		*  [0]: identifier (String)
		*  [1]: action (String: view/edit)
		*  @return: Object
		*/
		getSinglePackage( { commit, state }, params ) {

			const identifier = params[0];
			const action = params[1];

			return new Promise ( (resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/packages/' + identifier,
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					response.data.price = response.data.price / 100;
					commit( 'updateActivePackage', response.data );
					commit( 'updateStatus', action );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /POST packages API
		*  Add a new package to the server
		*  @params: Object (packages data)
		*  @return: Object
		*/
		addPackage( { commit, state }, data ) {

			return new Promise ( (resolve, reject ) => {

				const postData = {
					type: data.type,
					category: data.category,
					pricingType: data.pricingType,
					label: data.label,
					description: data.description,
					pricePerHour: data.pricePerHour,
					totalHours: data.totalHours,
					numCleaners: data.numCleaners,
					hoursPerCleaner: data.hoursPerCleaner,
					breakHours: data.breakHours,
					suppliesCost: data.suppliesCost,
					suppliesIncluded: data.suppliesIncluded,
					suppliesToBePrepared: data.suppliesToBePrepared,
					startTime: data.startTime,
					credits: data.credits,
					price: data.price * 100
				};

				global.axios.request({
					method: 'post',
					url: '/packages',
					validateStatus: ( status ) => { return status == 201; },
					data: postData
				})
				.then(response => {
					commit( 'addPackage', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});


		},

		/* 
		*  /POST/:id packages API
		*  Edits an existing package into the server
		*  @params: Object (packages data)
		*  @return: Object
		*/
		editPackage( { commit, state }, data ) {

			return new Promise ((resolve, reject ) => {

				const postData = {
					type: data.type,
					category: data.category,
					pricingType: data.pricingType,
					label: data.label,
					description: data.description,
					pricePerHour: data.pricePerHour,
					totalHours: data.totalHours,
					numCleaners: data.numCleaners,
					hoursPerCleaner: data.hoursPerCleaner,
					breakHours: data.breakHours,
					suppliesCost: data.suppliesCost,
					suppliesIncluded: data.suppliesIncluded,
					suppliesToBePrepared: data.suppliesToBePrepared,
					startTime: data.startTime,
					credits: data.credits,
					price: data.price * 100
				};

				global.axios.request({
					method: 'post',
					url: '/packages/' + data.id + '/update',
					validateStatus: ( status ) => { return status == 200; },
					data: postData
				})
				.then(response => {
					commit( 'addPackage', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /DELETE/:id packages API
		*  Removes an existing package into the server
		*  @params: identifier (String)
		*  @return: 200 OK
		*/
		deletePackage( { commit, state }, identifier ) {

			return new Promise ((resolve, reject ) => {

				global.axios.request({
					method: 'post',
					url: '/packages/' + identifier + '/trash',
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'deletePackage', identifier );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /POST/:id/untrash packages API
		*  Restores a package into the server from the trash
		*  @params: identifier (String)
		*  @return: 200 OK
		*/
		untrashPackage( { commit, state }, identifier ) {

			return new Promise ( (resolve, reject) => {

				global.axios.request({
					method: 'post',
					url: '/packages/' + identifier + '/untrash',
					validateStatus: ( status ) => { return status == 200; },
				})
				.then(response => {
					const updatedList = state.packagesList.map(item => {
						if (item.id === identifier ) {
							let holder = item;
							holder.trash = 0;
							return holder;
						} else {
							return item;
						};
					});
					commit( 'updatePackageList', updatedList );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /GET packages API CSV
		*  Get all packages from the server as a CSV
		*  (different headers)
		*  @return: Array
		*/
		getPackagesCsv( { commit } ) {

			window.open( process.env.ENDPOINT + '/packages?download=1&from=0&size=9999999' );

		},

		reset( { commit, state } ) {
			commit( 'resetState' );
		}

	}
}


// WEBPACK FOOTER //
// ./src/custom/controllers/Packages.js